<template>
  <div class="g-bd">
    <!-- banner -->
    <div class="con-banner">
      <el-carousel trigger="click" height="400px" arrow="never">
        <a
          :href="item.linkUrl ? `${item.linkUrl}` : 'javascript:void(0);'"
          v-for="item in bannerList"
          :key="item.id"
          :target="item.linkUrl ? '_blank' : '_self'"
        >
          <el-carousel-item
            :style="`background:${item.backgroundColor};background-size: cover;
-webkit-background-size: cover;
-o-background-size: cover;
zoom: 1;`"
          >
            <div :class="$route.query.siteId==6?'item-con rural-promote':'item-con'" >
              <img :src="imgUrl + item.path" alt />
            </div>
          </el-carousel-item>
        </a>
      </el-carousel>
    </div>
    <!-- 院校 -->
    <div class="school-body" v-if="!!schoolFlag">
      <div class="school-box">
        <div class="school-content">
          <school ref="school" @getSchool="getSchool"></school>
        </div>
      </div>
    </div>
    <!-- 热门课程 TODO-->
    <div class="hotCourse-body" v-if="!!recommendFlag">
      <div class="hotCourse-box">
        <div class="hotCourse-content">
          <recommend @getRecommend="getRecommend"></recommend>
        </div>
      </div>
    </div>
    <div class="hotTeacher-body" v-if="!!teacherFlag">
      <div class="hotTeacher-box">
        <div class="body-tool hotTeacher-tool">
          <h2>热门名师</h2>
          <span @click="toTeacherList">更多名师 &gt;</span>
        </div>
        <div class="hotTeacher-content">
          <hotTeacher ref="hotTeacher" @getTeacher="getTeacher"></hotTeacher>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import school from "./school.vue";
import hotCourse from "./hotCourse.vue";
import recommend from "./rankCourse.vue";
import { setTimeout } from "timers";
import hotTeacher from "./hotTeacher.vue";

export default {
  components: {
    school,
    hotCourse,
    recommend,
    hotTeacher,
  },
  data() {
    return {
      bannerList: [],
      schoolFlag: true,
      recommendFlag: true,
      teacherFlag: true,
      imgUrl: this.$setting.fdsDomain,
    };
  },
  watch: {},
  mounted() {
    this.getbanner();
  },
  methods: {
    getSchool(val) {
      this.schoolFlag = val;
    },
    getRecommend(val) {
      this.recommendFlag = val;
    },
    getTeacher(val) {
      this.teacherFlag = val;
    },
    openCourse(key, keyPath) {
      window.open(
        `/course?pathFalg=new&categoryId=${key}&columnId=&school=&isOnline=3&status=&key=`
      );
    },
    toCourseList(val) {
      // window.location.href = `/course`;
      window.open(
        `/course?pathFalg=${val}&categoryId=&columnId=&school=&isOnline=3&status=&key=`
      );
    },
    toTeacherList(val) {
      // window.location.href = `/teacher`;
      window.open(`/teacher`);
    },
    getbanner() {
      let par = {
        tagCourseId: this.$route.query.siteId - 1,
      };
      this.$http.post("/api/web/banner/list", par).then((res) => {
        this.bannerList = res.data;
        // this.sysCountPV();
      });
    },
  },
};
</script>
<style lang="scss">
.data-count {
  .data-body {
    ul {
      width: 1200px;
      margin: 0 auto;
      li {
        width: 299px;
        padding: 20px 0 40px 0;
        float: left;
        align-items: center;
        text-align: center;
        .item-icon {
          width: 30px;
          height: 30px;
          margin: auto;
        }
        .item-border {
          font-size: 36px;
          font-weight: bold;
          border-right: solid 1px #ddddddff;
        }
        .item-noborder {
          border-right: none;
        }
        .item-title {
          font-size: 12px;
          color: #333;
        }
      }
    }
  }
}
.child-body {
  width: 1200px;
  margin: 0 auto;
  .child-box {
    padding: 40px 0 30px;

    .child-content {
      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        li {
          flex: 1;
          max-width: 278px;
          min-width: 278px;
          height: 120px;
          background: #ccc;
          border-radius: 4px;
          position: relative;
          .item-bg {
            position: absolute;
            top: 0;
            left: 0;
            background: #000;
            opacity: 0.5;
            width: 278px;
            height: 120px;
            border-radius: 4px;
          }
          .item-con {
            top: 0;
            left: 0;
            position: absolute;
            color: #fff;
            z-index: 1;
            line-height: 120px;
            width: 278px;
            height: 120px;
            text-align: center;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
.con-menu {
  width: 1200px;
  position: relative;
  margin: 0 auto;
  .con-nav-list {
    position: absolute;
    left: 0;
    top: 0px;
    width: 210px;

    ul {
      padding: 11px 0;
      position: absolute;
      width: 210px;
      background: #fff;
      z-index: 100;
      li {
        color: #333;
        line-height: 42px;
        height: 42px;
        border-radius: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 20px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.is-active {
          color: #3685fdff;
          background: #ebf3ffff;
        }
        &:hover {
          color: #3685fdff;
          background: #ebf3ffff;
        }
      }
    }
  }
  .pos-black-bg {
    position: absolute;
    right: 0;
    top: 50px;
    z-index: 10;
    background: #000000ff;
    opacity: 0.4;
    height: 305px;
    width: 250px;
    border-radius: 8px;
  }
  .pos-black {
    position: absolute;
    right: 0;
    top: 50px;
    z-index: 11;
    height: 305px;
    width: 250px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    .pos-news {
      ul {
        width: 250px;
        height: 305px;
        z-index: 100;
        padding: 20px;
        border-radius: 4px;
        li {
          width: 100%;
          font-size: 14px;
          line-height: 30px;

          cursor: pointer;
          a {
            display: block;
            color: #fff;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &:hover {
              color: #3685fd;
            }
          }
        }
        .pos-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 5px;
          padding: 0 0 10px 0;
          h3 {
            color: #fff;
            font-size: 16px;
          }
          span {
            font-size: 14px;
            color: #999;
            cursor: pointer;
          }
          span:hover {
            color: #3685fd;
          }
        }
      }
    }
  }
}
.con-banner {
  height: 400px;
  width: 100%;
  margin: 0 auto;
  // overflow: hidden;
  display: flex;
  justify-content: space-between; // position: relative;

  .el-carousel {
    flex: 1;
    overflow: hidden;
    .el-carousel__container {
      margin: 0 auto;
      .item-con {
        position: relative;
        width: auto;
        height: 400px;
        margin: 0 auto;
        &.rural-promote{
          width: 100%;
        }
      }
    }
  }

  .el-carousel__item img {
    // width: 100%;
    height: 100%;
    margin: 0 auto;
    display: block;
  }
}
.school-body {
  background: #f7f8f9;
  .school-box {
    width: 1200px;
    padding: 40px 0 30px;
    margin: 0 auto;
  }
}
.course-body {
  background: #fff;
  .course-box {
    width: 1200px;
    padding: 40px 0px;
    margin: 0 auto;
  }
}
.hotCourse-body {
  background: #fff;
  .hotCourse-box {
    width: 1200px;
    padding: 50px 0 0 0;
    margin: 0 auto;
  }
}
.hotTeacher-body {
  background-image: url(/images/index_bg.png);
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  .hotTeacher-box {
    width: 1200px;
    padding: 50px 0 60px 0;
    margin: 0 auto;
    .hotTeacher-tool {
      h2,
      span {
        color: #fff;
      }
      span:hover {
        color: #3685fd;
      }
    }
  }
}
.slort-body {
  background: #fff;
  .slort-box {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    .slort-content {
      display: flex;
      margin-top: 20px;
    }
  }
}
.body-tool {
  display: flex;
  justify-content: space-between;
  align-items: center;
  h2 {
    font-size: 26px;
  }
  span {
    font-size: 14px;
    color: #777;
    cursor: pointer;
    &:hover {
      color: #3685fd;
    }
  }
}
</style>
